import { CircleCheck, Clock3, OctagonAlert } from 'lucide-react';
import { memo } from 'react';

import { type V3ChatActions } from '@apps/web/features/phoebe_chat_v3/model/actions';
import { type V3StatusEntry } from '@apps/web/features/phoebe_chat_v3/model/transcript';
import { V3AmbientButton } from '@apps/web/features/phoebe_chat_v3/ui/ambient_components';
import { cn } from '@apps/web/lib/utils';

export const V3StatusRow = memo(function V3StatusRow({
    entry,
    actions,
}: {
    readonly entry: V3StatusEntry;
    readonly actions: V3ChatActions;
}) {
    const StatusIcon =
        entry.tone === 'success'
            ? CircleCheck
            : entry.tone === 'destructive'
              ? OctagonAlert
              : Clock3;
    return (
        <div
            className={cn(
                'flex max-w-[700px] items-center gap-2.5 text-sm leading-5 text-[#002429]',
                entry.tone === 'success' && '[&_svg]:text-[#05614F]',
                entry.tone === 'destructive' && '[&_svg]:text-[#A8002E]',
                entry.tone === 'default' && '[&_svg]:text-[#617578]',
            )}
        >
            <StatusIcon aria-hidden="true" className="size-[18px] shrink-0" />
            <p className="font-semibold">{entry.label}</p>
            {entry.detail ? (
                <p className="min-w-0 text-[#244045]">{entry.detail}</p>
            ) : null}
            <span className="min-w-0 flex-1" />
            {entry.canRetry && actions.onRetry ? (
                <V3AmbientButton
                    type="button"
                    variant="ghost"
                    className="h-auto px-0 text-[13px] leading-[18px] text-[#5533EE] hover:bg-transparent hover:text-[#4629C7]"
                    disabled={actions.isRetryDisabled}
                    onClick={() => {
                        void actions.onRetry?.();
                    }}
                >
                    Retry
                </V3AmbientButton>
            ) : null}
        </div>
    );
});
